//changed due to package upgrade
import React, { useState } from 'react';
import AppGridContainer from '@projectK/components/AppGridContainer';
import AppTextField from '@projectK/components/AppTextField';
import { Box, Button, Divider, Grid, Stack, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import EditIcon from '@mui/icons-material/Edit';
import AppCard from '@projectK/components/AppCard';
import jwtAxios from '@projectK/services/auth/JWT';
import { useInfoViewActionsContext } from '@projectK/context';
import AppInfoView from '@projectK/components/AppInfoView';
import PropTypes from 'prop-types';

const Apex = ({ settings }) => {
  const [isEdit, setIsEdit] = useState(false);
  const infoViewActionsContext = useInfoViewActionsContext();

  return (
    <>
      <AppCard>
        <Formik
          validateOnChange={true}
          initialValues={{
            enable_apex: settings?.enable_apex || '',
            key: settings?.key || '',
            token: settings?.token || '',
            sidebar_url: settings?.sidebar_url || '',
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            // Prepare the data for submission
            const settingsArray = Object.keys(values).map((fieldName) => ({
              setting_variant: 'apex',
              setting_slug: fieldName,
              setting_value: values[fieldName],
              is_active: true, // Set is_active as needed
            }));

            jwtAxios
              .put(`/app-settings/apex/`, settingsArray)
              .then((response) => {
                setSubmitting(false);
                setIsEdit(false);
                infoViewActionsContext.showMessage(
                  'Apex Details updated successfully!',
                );
              })
              .catch((error) => {
                // Handle the error here
                infoViewActionsContext.fetchError(error.message);
                console.error('Error updating settings:', error);
                setSubmitting(false);
              });
          }}
        >
          <Form noValidate autoComplete='off'>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box>
                <Typography variant='h4'>Apex Settings</Typography>
                <Typography
                  variant='body1'
                  sx={{ mt: 2, color: 'text.secondary' }}
                >
                  These settings allow you to integrate with APEX.
                </Typography>
              </Box>
              <Box>
                {!isEdit && (
                  <EditIcon
                    sx={{ cursor: 'pointer' }}
                    onClick={() => setIsEdit(true)}
                  />
                )}
              </Box>
            </Box>
            <Divider sx={{ my: 4 }} />
            <AppGridContainer>
              <Grid size={{ xs: 12, md: 12 }}>
                <Box
                  sx={{
                    border: '1px solid #EAECF0',
                    p: 6,
                    borderRadius: 3,
                    boxShadow:
                      '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
                  }}
                >
                  <AppGridContainer>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <AppTextField
                        name='enable_apex'
                        variant='outlined'
                        sx={{
                          width: '100%',
                          my: 2,
                        }}
                        label='APEX Enabled'
                        slotProps={{
                          input: {
                            readOnly: !isEdit,
                          },
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <AppTextField
                        name='sidebar_url'
                        variant='outlined'
                        sx={{
                          width: '100%',
                          my: 2,
                        }}
                        label='Sidebar URL'
                        slotProps={{
                          input: {
                            readOnly: !isEdit,
                          },
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <AppTextField
                        name='key'
                        variant='outlined'
                        sx={{
                          width: '100%',
                          my: 2,
                        }}
                        label='Key'
                        slotProps={{
                          input: {
                            readOnly: !isEdit,
                          },
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <AppTextField
                        name='token'
                        variant='outlined'
                        sx={{
                          width: '100%',
                          my: 2,
                        }}
                        label='Token'
                        slotProps={{
                          input: {
                            readOnly: !isEdit,
                          },
                        }}
                      />
                    </Grid>
                  </AppGridContainer>
                </Box>
              </Grid>
            </AppGridContainer>
            {isEdit && (
              <Stack
                direction='row'
                justifyContent='flex-end'
                spacing={5}
                sx={{ mt: 3 }}
              >
                <Button
                  sx={{ color: 'text.secondary' }}
                  onClick={() => setIsEdit(false)}
                >
                  Cancel
                </Button>
                <Button variant='contained' color='primary' type='submit'>
                  Save
                </Button>
              </Stack>
            )}
          </Form>
        </Formik>
      </AppCard>
      <AppInfoView />
    </>
  );
};
Apex.propTypes = {
  settings: PropTypes.object,
};
export default Apex;
